import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-in",
  "use": "icon-in-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-in\">\n    <path d=\"M4.2 8.375h3.489V19.1H4.2zm12.99.126c-.036-.012-.071-.025-.11-.035a2.261 2.261 0 0 0-.142-.028 3.127 3.127 0 0 0-.626-.063c-2.033 0-3.323 1.48-3.748 2.05v-2.05H9.075V19.1h3.489v-5.85s2.636-3.672 3.748-.975V19.1H19.8v-7.237c0-1.62-1.11-2.971-2.61-3.362zM5.907 6.913a1.706 1.706 0 1 0 0-3.413 1.706 1.706 0 0 0 0 3.412z\" fill=\"#000018\" fill-rule=\"nonzero\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol